import { render, staticRenderFns } from "./ydList.vue?vue&type=template&id=6b507370&scoped=true&"
import script from "./ydList.vue?vue&type=script&lang=js&"
export * from "./ydList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b507370",
  null
  
)

export default component.exports